import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ImportWizardDialogService {
    private dialog = inject(MatDialog);

    async openImportWizard(component: any) {
        const dialogRef = this.dialog.open(component, {
            height: '80%',
            width: '80%',
        });
        return lastValueFrom(dialogRef.afterClosed());
    }

    close(): void {
        this.dialog.closeAll();
    }
}
